import { LANG_FLAG_CODE, type Lang } from "@/i18n/locales";

/**
 * Renders a reliable SVG country flag for a language. Uses self-rendering SVGs
 * (via flagcdn) so flags display consistently across all platforms, unlike
 * emoji flags which break on Windows and many headless environments.
 */
const Flag = ({
  lang,
  className = "",
  size = 20,
}: {
  lang: Lang;
  className?: string;
  size?: number;
}) => {
  const code = LANG_FLAG_CODE[lang];
  return (
    <img
      src={`https://flagcdn.com/${code}.svg`}
      alt=""
      aria-hidden="true"
      width={size}
      height={size}
      loading="lazy"
      className={`inline-block shrink-0 rounded-[3px] object-cover shadow-sm ring-1 ring-black/10 ${className}`}
      style={{ width: size, height: size }}
    />
  );
};

export default Flag;
